// import React, { useEffect } from "react";
// import { API_URL } from "../config";

// const Freshdesk = () => {
//     const freshdeskUrl = "https://streetgains-help.freshdesk.com/a/tickets/filters/all_tickets";

//     useEffect(() => {
//         // Automatically open Freshdesk in a new tab when component mounts
//         window.open(freshdeskUrl, "_blank", "noopener,noreferrer");
//     }, []);

//     const handleOpenFreshdesk = () => {
//         window.open(freshdeskUrl, "_blank", "noopener,noreferrer");
//     };

//     return (
//         <div className="mt-4" style={{
//             height: "100vh",
//             width: "100%",
//             padding: "40px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             textAlign: "center"
//         }}>
//             <h2 style={{ marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>
//                 Freshdesk Support
//             </h2>
//             <p style={{ marginBottom: "30px", color: "#666", maxWidth: "600px" }}>
//                 Freshdesk has been opened in a new tab. If it didn't open automatically,
//                 please click the button below to access the support portal.
//             </p>
//             <button
//                 onClick={handleOpenFreshdesk}
//                 style={{
//                     padding: "12px 24px",
//                     fontSize: "16px",
//                     fontWeight: "500",
//                     color: "#fff",
//                     backgroundColor: "#007bff",
//                     border: "none",
//                     borderRadius: "6px",
//                     cursor: "pointer",
//                     transition: "background-color 0.2s"
//                 }}
//                 onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
//                 onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}
//             >
//                 Open Freshdesk Support
//             </button>
//         </div>
//     );
// };

// export default Freshdesk;

/* eslint-disable*/
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

const Freshdesk = () => {
    const freshdeskUrl = "https://streetgains-help.freshdesk.com/a/tickets/filters/all_tickets";

    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTickets();
    }, []);

    const fetchTickets = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${API_URL}common/tickets-freshdesk`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setTickets(res.data?.data || []);
        } catch (error) {
            console.error("Error fetching Freshdesk tickets:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenFreshdesk = () => {
        window.open(freshdeskUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="mt-4 p-4" style={{ width: "100%" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
                <h2 style={{ fontWeight: 700 }}>Freshdesk Tickets</h2>
                <button
                    onClick={handleOpenFreshdesk}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        cursor: "pointer"
                    }}
                >
                    Open Freshdesk Support
                </button>
            </div>

            {loading ? (
                <p>Loading tickets...</p>
            ) : tickets.length === 0 ? (
                <p>No tickets found.</p>
            ) : (
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        background: "#fff",
                        borderRadius: 8,
                        overflow: "hidden"
                    }}
                >
                    <thead style={{ backgroundColor: "#f4f4f4" }}>
                        <tr>
                            <th style={thStyle}>ID</th>
                            <th style={thStyle}>Subject</th>
                            <th style={thStyle}>Status</th>
                            <th style={thStyle}>Priority</th>
                            <th style={thStyle}>Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tickets.map((ticket) => (
                            <tr key={ticket.id} style={trStyle}>
                                <td style={tdStyle}>{ticket.id}</td>
                                <td style={tdStyle}>{ticket.subject}</td>
                                <td style={tdStyle}>{statusLabel(ticket.status)}</td>
                                <td style={tdStyle}>{priorityLabel(ticket.priority)}</td>
                                <td style={tdStyle}>
                                    {new Date(ticket.created_at).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

// Table Styling
const thStyle = {
    padding: 12,
    textAlign: "left",
    fontWeight: 600,
    fontSize: 14,
    borderBottom: "2px solid #ddd"
};

const tdStyle = {
    padding: 12,
    borderBottom: "1px solid #eee",
    fontSize: 14
};

const trStyle = {
    cursor: "pointer"
};

// Status Display
const statusLabel = (status) => {
    const map = {
        2: "Open",
        3: "Pending",
        4: "Resolved",
        5: "Closed"
    };
    return map[status] || "Unknown";
};

// Priority Display
const priorityLabel = (priority) => {
    const map = {
        1: "Low",
        2: "Medium",
        3: "High",
        4: "Urgent"
    };
    return map[priority] || "Unknown";
};

export default Freshdesk;
